var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgLogoVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-visa_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 323.7",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logo-visa_svg__st0{fill:#00579f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-visa_svg__g4158",
    transform: "matrix(4.42996 0 0 4.42996 -81.166 -105.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-visa_svg__polygon9",
    className: "logo-visa_svg__st0",
    d: "M116.1 95.7H97.9L109.3 25h18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-visa_svg__path11",
    className: "logo-visa_svg__st0",
    d: "M182.4 26.7c-3.6-1.4-9.3-3-16.4-3-18.1 0-30.8 9.6-30.9 23.4-.1 10.2 9.1 15.8 16 19.2 7.1 3.5 9.5 5.7 9.5 8.8-.1 4.7-5.7 6.9-11 6.9-7.3 0-11.2-1.1-17.2-3.8l-2.4-1.1-2.4 15.9c4.3 2 12.2 3.7 20.4 3.8 19.2 0 31.7-9.5 31.8-24.2.1-8.1-4.8-14.2-15.4-19.3-6.4-3.2-10.3-5.4-10.3-8.7.1-3 3.3-6.1 10.5-6.1 5.9-.2 10.3 1.3 13.6 2.7l1.7.8 2.5-15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-visa_svg__path13",
    className: "logo-visa_svg__st0",
    d: "M206.7 70.7c1.5-4.1 7.3-19.8 7.3-19.8-.1.2 1.5-4.1 2.4-6.8l1.3 6.1s3.5 16.9 4.2 20.5h-15.2zM229.3 25h-14.1c-4.4 0-7.7 1.3-9.6 5.9l-27.2 64.9h19.2s3.2-8.7 3.8-10.6h23.5c.5 2.5 2.2 10.6 2.2 10.6H244L229.3 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-visa_svg__path15",
    className: "logo-visa_svg__st0",
    d: "M82.6 25L64.7 73.2l-2-9.8C59.4 52.2 49 39.9 37.4 33.8l16.4 61.8h19.3L101.9 25H82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo-visa_svg__path17",
    d: "M48 25H18.6l-.3 1.4c23 5.9 38.2 20 44.4 37l-6.4-32.5c-1-4.5-4.3-5.8-8.3-5.9z",
    fill: "#faa61a"
  }))));
}

export default SvgLogoVisa;